// extracted by mini-css-extract-plugin
export default {"container":"TournamentsConsole_container__J-o2+","tabs":"TournamentsConsole_tabs__1oMbz","activeTab":"TournamentsConsole_activeTab__B4+eS"};